import { useLayoutEffect } from 'react';

const TOP_VARIABLE = '--lms-navigation-top';
const ANIMATION_TRACKING_MS = 500;
const WINDOW_EVENTS = ['scroll', 'resize', 'pageshow'] as const;

const getVisibleBottom = (element: Element | null | undefined): number => {
    if (!element) return 0;

    const { display, visibility } = getComputedStyle(element);
    if (display === 'none' || visibility === 'hidden') return 0;

    const { width, height, bottom } = element.getBoundingClientRect();
    return width > 0 && height > 0 ? bottom : 0;
};

export const useModuleNavigationTop = (portal: HTMLElement | null) => {
    useLayoutEffect(() => {
        if (!portal) return;

        let animationFrame = 0;
        let trackUntil = 0;
        const observedElements = new Set<Element>();
        const resizeObserver = new ResizeObserver(scheduleUpdate);
        const mutationObserver = new MutationObserver(scheduleUpdate);

        const observeElement = (element: Element | null | undefined) => {
            if (!element || observedElements.has(element)) return;

            observedElements.add(element);
            resizeObserver.observe(element);
            mutationObserver.observe(element, {
                attributes: true,
                attributeFilter: ['style', 'class'],
            });
        };

        const updatePosition = () => {
            const header = document.getElementById('navbar')?.parentElement;
            const dock = document.querySelector('[data-hse-index-dock]');
            observeElement(header);
            observeElement(dock);

            if (header) {
                const bottom = Math.max(0, getVisibleBottom(header), getVisibleBottom(dock));
                portal.style.setProperty(TOP_VARIABLE, `${bottom}px`);
            }

            animationFrame = performance.now() < trackUntil
                ? requestAnimationFrame(updatePosition)
                : 0;
        };

        function scheduleUpdate() {
            trackUntil = performance.now() + ANIMATION_TRACKING_MS;
            if (!animationFrame) animationFrame = requestAnimationFrame(updatePosition);
        }

        updatePosition();
        scheduleUpdate();
        WINDOW_EVENTS.forEach(event => window.addEventListener(event, scheduleUpdate, { passive: true }));

        return () => {
            cancelAnimationFrame(animationFrame);
            resizeObserver.disconnect();
            mutationObserver.disconnect();
            WINDOW_EVENTS.forEach(event => window.removeEventListener(event, scheduleUpdate));
            portal.style.removeProperty(TOP_VARIABLE);
        };
    }, [portal]);
};
import { useLayoutEffect } from 'react';

const TOP_VARIABLE = '--lms-navigation-top';
const ANIMATION_TRACKING_MS = 500;
const WINDOW_EVENTS = ['scroll', 'resize', 'pageshow'] as const;

const getVisibleBottom = (element: Element | null | undefined): number => {
    if (!element) return 0;

    const { display, visibility } = getComputedStyle(element);
    if (display === 'none' || visibility === 'hidden') return 0;

    const { width, height, bottom } = element.getBoundingClientRect();
    return width > 0 && height > 0 ? bottom : 0;
};

export const useModuleNavigationTop = (portal: HTMLElement | null) => {
    useLayoutEffect(() => {
        if (!portal) return;

        let animationFrame = 0;
        let trackUntil = 0;
        const observedElements = new Set<Element>();
        const resizeObserver = new ResizeObserver(scheduleUpdate);
        const mutationObserver = new MutationObserver(scheduleUpdate);

        const observeElement = (element: Element | null | undefined) => {
            if (!element || observedElements.has(element)) return;

            observedElements.add(element);
            resizeObserver.observe(element);
            mutationObserver.observe(element, {
                attributes: true,
                attributeFilter: ['style', 'class'],
            });
        };

        const updatePosition = () => {
            const header = document.getElementById('navbar')?.parentElement;
            const dock = document.querySelector('[data-hse-index-dock]');
            observeElement(header);
            observeElement(dock);

            if (header) {
                const bottom = Math.max(0, getVisibleBottom(header), getVisibleBottom(dock));
                portal.style.setProperty(TOP_VARIABLE, `${bottom}px`);
            }

            animationFrame = performance.now() < trackUntil
                ? requestAnimationFrame(updatePosition)
                : 0;
        };

        function scheduleUpdate() {
            trackUntil = performance.now() + ANIMATION_TRACKING_MS;
            if (!animationFrame) animationFrame = requestAnimationFrame(updatePosition);
        }

        updatePosition();
        scheduleUpdate();
        WINDOW_EVENTS.forEach(event => window.addEventListener(event, scheduleUpdate, { passive: true }));

        return () => {
            cancelAnimationFrame(animationFrame);
            resizeObserver.disconnect();
            mutationObserver.disconnect();
            WINDOW_EVENTS.forEach(event => window.removeEventListener(event, scheduleUpdate));
            portal.style.removeProperty(TOP_VARIABLE);
        };
    }, [portal]);
};
